import classNames from 'classnames';
import React from 'react';
import { tableHeaderClasses, TableHeaderSC } from './table-header.styled';

interface TableHeaderProps {
  title?: React.ReactNode;
  extra?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const TableHeader: React.FunctionComponent<TableHeaderProps> = ({
  className,
  extra,
  style,
  title,
}) => {
  return (
    <TableHeaderSC className={classNames(tableHeaderClasses.header, className)} style={style}>
      <div className={tableHeaderClasses.headerTitle}>{title}</div>
      <div className={tableHeaderClasses.headerExtra}>{extra}</div>
    </TableHeaderSC>
  );
};

export default TableHeader;
